import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";

import { FaceLivenessDetector } from '@aws-amplify/ui-react-liveness';
import { Loader, ThemeProvider, Alert } from '@aws-amplify/ui-react';

import instance from '../api/userApi';

import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';
import awsexports from '../../src/aws-exports';

Amplify.configure(awsexports);

export default function FaceScanner() {

    const navigatee = useNavigate();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    const [loading, setLoading] = React.useState(true);
    const [createLivenessApiData, setCreateLivenessApiData] = React.useState(null);

    React.useEffect(() => {

        try {

            if (token == (null || undefined)) {
                navigatee('/');
            }

            const decoded = jwtDecode(token);
            const now = Date.now() / 1000; // current time in seconds

            if (decoded.exp < now) {
                //  alert('Token expired')
                navigatee('/');
                throw new Error('Token expired');
            }

        } catch (e) {
            // alert(e.message)
            console.log('nav ' + e)
            navigatee('/');
        }

    }, [token, navigatee]);

    React.useEffect(() => {

        const fetchCreateLiveness = async () => {

            try {
                const response = await instance.get(`/createLivenessSession`);

                await new Promise((r) => setTimeout(r, 2000));
                const mockResponse = { sessionId: response.data };
                const data = mockResponse
                setCreateLivenessApiData(data);
                setLoading(false);

            } catch (e) {
                // alert(e.message)
                console.log('erp ' + e)
            }

        };

        fetchCreateLiveness();
    }, []);

    const handleAnalysisComplete = async () => {

        try {

            const sessionId = createLivenessApiData.sessionId

            const response = await instance.get(`/getLivenessResult/${sessionId}`);

            if (response.data) {

                // const decoded = jwtDecode(token);
                // const userId = decoded.userId 
                //we doing this back om the app because of this error No 'Access-Control-Allow-Origin
                //  await instance.patch(`/updateAccountStatus/${userId}`, { accountVerified: true });

                //  console.log('Verification Passed');
                //  alert('User is live');
                window.location.href = `africamatch://verification-result?isLive=${response.data}`;

            } else {
                // console.log('Verification Failed');
                window.location.href = `africamatch://verification-result?isLive=${response.data}`;

                //  alert('User is not live');
            }
        } catch (e) {
            //alert(e.message)
            console.log('erp ' + e)
        }

    };

    return (
        <div style={{ backgroundColor: '#ffffff' }}>
            <ThemeProvider>
                {loading ? (
                    <Loader />
                ) : (
                    <FaceLivenessDetector
                        sessionId={createLivenessApiData.sessionId}
                        region="us-east-1"
                        onAnalysisComplete={handleAnalysisComplete}
                        onError={(error) => {
                            console.error(error);
                            // alert(error.message)
                        }}
                        displayText={{
                            hintCenterFaceText: 'Tap ready below',
                            startScreenBeginCheckText: "I'm Ready"
                        }}
                        components={{
                            PhotosensitiveWarning: () => {
                                return null
                            },
                        }}
                    />
                )}
            </ThemeProvider>
        </div>
    );
}